export enum ViewPrognosesOptions {
  SUBMITTED_TO_ME = 'submitted-to-me',
}
